/* eslint-disable react/no-deprecated */
/*!

=========================================================
* Purity UI Dashboard - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/purity-ui-dashboard/blob/master/LICENSE.md)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import PrivateRoute from "views/Auth/PrivateRoute.js";
import { CsvDataProvider } from "context/CsvDataContext";

ReactDOM.render(
  <CsvDataProvider>
    <HashRouter>
      <Switch>
        <Route path={`/auth`} component={AuthLayout} />
        <PrivateRoute
          path={`/admin/unisono`}
          component={AdminLayout}
          requiredEndpoints={"https://visa.ex.zana.ai/visa-vita-backend/api/login"} />

        <PrivateRoute path={`/admin`} component={AdminLayout} />

        <Redirect from={`/`} to="auth/signin" />
      </Switch>
    </HashRouter>
  </CsvDataProvider>,
  document.getElementById("root")
);
